import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { MailOutlined } from '@ant-design/icons';

function InputEmail({ value, onChange, placeholder, disabled }) {
  const [localValue, setLocalValue] = useState('');
  const [error, setError] = useState(false);
  const email = value !== undefined ? value : localValue;

  const handleChange = (e) => {
    const val = e.target.value;
    if (value === undefined) {
      setLocalValue(val);
    }
    onChange && onChange(val);
  };

  const validateEmail = (val) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(val);
  };

  const handleBlur = () => {
    if (email && !validateEmail(email)) {
      setError(true);
    } else {
      setError(false);
    }
  };

  const handleFocus = () => {
    setError(false);
  };

  return (
    <>
      <Input
        disabled={disabled}
        prefix={<MailOutlined style={{ marginRight: 4 }} />}
        value={email}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        placeholder={placeholder}
        allowClear
      />
    </>
  );
}

InputEmail.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

InputEmail.defaultProps = {
  placeholder: 'örnek@domain.com',
};

export default InputEmail;
